import httpPost from "./httppost";
const domain = "https://vip.foxitreader.cn";

// 获取vipToken
export const vipTokens = (config = {}) => {
  return httpPost({
    url: `${domain}/v2/tokens/${config.fid}`,
    // params:config.params,
    config
  });
};